import React from 'react';
import { MoneyBlocks } from './MoneyBlocks';
import { ContentManager, WordpressPost, WordpressSidebar } from '@benzinga/content-manager';
import { Session } from '@benzinga/session';
// import { AmplyWidget } from '@benzinga/ads';
// import { appEnvironment, appName } from '@benzinga/utils';
import { NoFirstRender } from '@benzinga/hooks';

const LayoutAdmin = React.lazy(() => import('@benzinga/blocks').then(module => ({ default: module.LayoutAdmin })));

export interface MoneySidebarProps {
  post?: WordpressPost | null;
  sidebar: WordpressSidebar;
}

export const MoneySidebar: React.FC<MoneySidebarProps> = ({ post, sidebar }) => {
  return (
    <div className="sidebar">
      <NoFirstRender>
        <React.Suspense>{sidebar && <LayoutAdmin post={sidebar} />}</React.Suspense>
      </NoFirstRender>
      <MoneyBlocks blocks={sidebar?.blocks} className="flex flex-col gap-4" post={post} type="sidebar" />
    </div>
  );
};

export const getMoneySidebar = async (session: Session, post_id: number) => {
  const contentManager = session.getManager(ContentManager);
  const pageRes = await contentManager.getPage(post_id);
  return pageRes?.ok ?? null;
};
